import SVG from 'react-inlinesvg';
import cx from 'classnames';
import { PropsWithChildren } from 'react';
import ButtonProps, { Align, ButtonTheme, Color, Size, TextOverflow, TextSize } from './Button.types';
import { CircularLoadingSpinner, SpinnerSize } from '../CircularLoadingSpinner/CircularLoadingSpinner';

const Button = ({
  ariaLabel,
  classNames,
  color = Color.PRIMARY,
  dataTestId,
  label,
  onClick,
  onMouseLeave,
  onMouseOver,
  onFocus,
  onBlur,
  isDisabled,
  size = Size.MEDIUM,
  svg,
  svgClassnames,
  ddActionName,
  textSize = TextSize.MEDIUM,
  textOverflow = TextOverflow.HIDDEN,
  align = Align.CENTER,
  isSpinner = false,
  dataPendoId,
  children,
}: PropsWithChildren<ButtonProps>): React.ReactElement => {
  return (
    <button
      data-test-id={dataTestId}
      type="button"
      onClick={onClick}
      onMouseOver={onMouseOver}
      onFocus={onFocus}
      onMouseLeave={onMouseLeave}
      onBlur={onBlur}
      disabled={isDisabled}
      aria-label={ariaLabel}
      data-dd-action-name={ddActionName ?? label}
      data-pendo-id={dataPendoId}
      className={cx(
        'flex items-center gap-1 rounded-md leading-none align-middle disabled:cursor-not-allowed disabled:bg-neutral-300 disabled:text-neutral-400',
        ButtonTheme.theme[color],
        ButtonTheme.size[size],
        ButtonTheme.textSize[textSize],
        ButtonTheme.align[align],
        classNames,
      )}
    >
      {isSpinner && (
        <div className="w-4 h-4">
          <CircularLoadingSpinner size={SpinnerSize.EXTRA_SMALL} />
        </div>
      )}
      {!isSpinner && svg ? <SVG src={svg} className={cx('fill-current inline-block w-4 h-4', svgClassnames)} /> : null}
      {label && (
        <span className={cx('whitespace-nowrap text-ellipsis', ButtonTheme.textOverflow[textOverflow])}>{label}</span>
      )}
      {children}
    </button>
  );
};

export default Button;
